/** NET10 Identity users have Guid ids. The old `user.id > 0` check treated every Guid as false. */
export function isAbpSessionUserId(id: unknown): boolean {
  if (id == null) {
    return false;
  }
  if (id === 0 || id === '0') {
    return false;
  }
  return true;
}
